'use server';
// Formulaire de contact : validation côté serveur puis courriel à CONTACT_TO
// (info@tg3r.com) par SMTP. Sans SMTP_HOST en développement, le message est
// écrit dans la console ; en production, l'envoi est refusé.
import * as v from 'valibot';
import nodemailer from 'nodemailer';
import { env } from 'virtual:env/server';

const TYPES = { fabricant: 'Fabricant ou transformateur', detaillant: 'Détaillant', restaurateur: 'Restaurateur' } as const;

const Payload = v.object({
  type: v.picklist(Object.keys(TYPES) as (keyof typeof TYPES)[]),
  entreprise: v.pipe(v.string(), v.trim(), v.minLength(1), v.maxLength(200)),
  contact: v.pipe(v.string(), v.trim(), v.minLength(1), v.maxLength(200)),
  telephone: v.pipe(v.string(), v.trim(), v.regex(/^[0-9()+.\s-]{10,20}$/)),
  courriel: v.pipe(v.string(), v.trim(), v.email(), v.maxLength(254)),
  produits: v.pipe(v.string(), v.trim(), v.minLength(1), v.maxLength(2000)),
  message: v.optional(v.pipe(v.string(), v.trim(), v.maxLength(5000)), ''),
  // Champ piège : rempli seulement par les robots.
  website: v.optional(v.string(), ''),
});
export type ContactPayload = v.InferInput<typeof Payload>;

export async function sendContact(input: ContactPayload): Promise<{ ok: true }> {
  const parsed = v.safeParse(Payload, input);
  if (!parsed.success) throw new Error('Certains champs sont invalides. Vérifiez le formulaire.');
  const d = parsed.output;
  if (d.website) return { ok: true }; // robot : on fait semblant

  const lines = [
    `Profil : ${TYPES[d.type]}`,
    `Entreprise : ${d.entreprise}`,
    `Contact : ${d.contact}`,
    `Téléphone : ${d.telephone}`,
    `Courriel : ${d.courriel}`,
    '',
    'Produits / marques représentés :',
    d.produits,
  ];
  if (d.message) lines.push('', 'Message :', d.message);
  const text = lines.join('\n');
  const subject = `Demande de contact — ${TYPES[d.type]} — ${d.entreprise}`;

  if (!env.SMTP_HOST) {
    if (process.env.NODE_ENV === 'production') {
      console.error('contact: SMTP_HOST manquant, message non envoyé');
      throw new Error("L'envoi est indisponible pour le moment. Écrivez-nous à info@tg3r.com.");
    }
    console.log(`\n[contact] (dev, sans SMTP) à ${env.CONTACT_TO}\nObjet : ${subject}\n${text}\n`);
    return { ok: true };
  }

  const transport = nodemailer.createTransport({
    host: env.SMTP_HOST,
    port: env.SMTP_PORT,
    secure: env.SMTP_SECURE === 'tls',
    auth: env.SMTP_USER ? { user: env.SMTP_USER, pass: env.SMTP_PASS ?? '' } : undefined,
  });
  try {
    await transport.sendMail({
      from: env.CONTACT_FROM,
      to: env.CONTACT_TO,
      replyTo: `${d.contact} <${d.courriel}>`,
      subject,
      text,
    });
  } catch (e) {
    console.error('contact: envoi SMTP échoué', e);
    throw new Error("L'envoi a échoué. Réessayez ou écrivez-nous à info@tg3r.com.");
  }
  return { ok: true };
}
